import { Component } from '@angular/core';

@Component({
  selector: 'rnpl-corporate-partner-form-skeleton',
  templateUrl: './corporate-partner-form-skeleton.component.html'
})
export class CorporatePartnerFormSkeletonComponent {

}
